export default (state, action) => {
  const { payload } = action;
  // TODO: should calculate the payload cause it could be a step number(like 3) or a status string(like "submit")
  const stepNum = payload;
  const stepIndex = parseInt(stepNum, 10) - 1;
  const { stepsList = [], steps = {} } = state;
  const activeStepName = stepsList[stepIndex];
  // open the first card of the active step by default
  const openedCardsList = activeStepName
    ? [steps[activeStepName].cardsList[0]]
    : [];

  return {
    ...state,
    activeStep: stepNum,
    openedCards: openedCardsList
  };
};
